module.exports = __webpack_public_path__ + "img/galery7.2b0eef6b.jpg";